import SidenavList from './SidenavList.vue';
import logo from '@/assets/img/logo-ct-dark.png';
import logoWhite from '@/assets/img/logo-ct.png';
import image from '@/assets/img/profile-layout-header.jpg';
import ConstCode from '@/common/constants/ConstCode';
import { mapState } from 'vuex';
export default {
  name: 'Index',
  components: {
    SidenavList
  },
  data() {
    return {
      logo,
      logoWhite,
      image
    };
  },
  computed: {
    basePath() {
      return ConstCode.MAIN_PATH;
    },
    ...mapState('layout', ['layout', 'isRTL', 'sidebarType', 'darkMode']),
    projectName() {
      return ConstCode.CODE_ENV_LIST.PROJECT_NAME;
    }
  },
  beforeUnmount() {
    this.$store.state.image;
  }
};